import React from 'react'; 
import PropTypes from 'prop-types';
import TextBox from '../Basic/TextBox';
import SectionHeader from '../Basic/SectionHeader';
import CountryRegions from './CountryRegions';

class PostBox extends React.Component {
    render() {
        const p = this.props;
        return (
            <div className="form-group">
                <SectionHeader title={p.title} />
                <div className="row">
                    <div className="col-md-2">
                        <TextBox id={p.name + "_poBox"} name={p.name + "_poBox"} title="P.O. box"
                            disabled={p.disabled} required maxLength={10} />
                    </div>
                    <div className="col-md-2">
                        <TextBox id={p.name + "_city"} name={p.name + "_city"} title="City/town"
                            disabled={p.disabled} required />
                    </div>
                    <div className="col-md-6">
                        <CountryRegions name={p.name} disabled={p.disabled} />
                    </div>
                    <div className="col-md-2">
                        <TextBox id={p.name + "_postalCode"} name={p.name + "_postalCode"} title="Postal code/zip"
                            disabled={p.disabled} required />
                    </div>
                </div>
            </div>
        );
    }
}

PostBox.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    disabled: PropTypes.bool
};

export default PostBox;

export function PostBoxValidation(name) {
    return [
        [name + "_poBox", p => p[name + "_poBox"], "P.O. box"],
        [name + "_city", p => p[name + "_city"], "City/town"],
        [name + "_country", p => p[name + "_country"], "Country"],
        [name + "_state", p => p[name + "_state"], "Province/state"],
        [name + "_postalCode", p => p[name + "_postalCode"], "Postal code/zip"],
    ];
}